import CodeMultiple from './Index.vue'
CodeMultiple.install = function(Vue) {
  Vue.component(CodeMultiple.name, CodeMultiple)
}


export default CodeMultiple
